// extracted by mini-css-extract-plugin
export var avatarContainer = "_gl-0";
export var avatarTypingWave = "_gl-i";
export var gray = "_gl-f";
export var green = "_gl-c";
export var icon = "_gl-9";
export var image = "_gl-1";
export var lg = "_gl-6";
export var md = "_gl-5";
export var presenceDot = "_gl-b";
export var red = "_gl-d";
export var sm = "_gl-4";
export var status = "_gl-a";
export var typingDot = "_gl-h";
export var typingPill = "_gl-g";
export var xl = "_gl-7";
export var xs = "_gl-3";
export var xxl = "_gl-8";
export var xxs = "_gl-2";
export var yellow = "_gl-e";